<template>    
  <ul class="side_menu">
    <div class="title">防災サポート</div>
    <div class="d_top">
      <li class="li_top" v-if="this.$store.getters.getStateIsAuthenticated"><router-link to="/areaList">地域</router-link></li>
      <li class="li_top" v-if="this.$store.getters.getStateIsAuthenticated"><router-link to="/areaGroupList">地域グループ</router-link></li>
      <li class="li_top" v-if="this.$store.getters.getStateIsAuthenticated"><router-link to="/disasterType">災害種別</router-link></li>
      <li class="li_top" v-if="this.$store.getters.getStateIsAuthenticated"><router-link to="/linkList">外部リンク</router-link></li>
      <li class="li_top" v-if="this.$store.getters.getStateIsAuthenticated && this.$store.getters.getStateIsPushAuth"><router-link to="/pushNotification">プッシュ通知</router-link></li>
      <li class="li_top" v-if="this.$store.getters.getStateIsAuthenticated && this.$store.getters.getStateIsPushAuth"><router-link to="/pushNotificationTraining">プッシュ通知(訓練用)</router-link></li>
      <li class="li_top" v-if="this.$store.getters.getStateIsAuthenticated"><router-link to="/printList">印刷設定</router-link></li>
      <li class="li_top" v-if="this.$store.getters.getStateIsAuthenticated"><router-link to="/shelterList">避難先</router-link></li>
    </div>
    <div class="d_bottom">
      <li v-if="this.$store.getters.getStateCompanyFlg == 1" class="li_bottom">組織ID: {{ this.$store.getters.getStateCompanyId }}</li>
      <li v-else class="li_bottom">{{ this.$store.getters.getStateChargeId }}</li>
      <!-- <li class="li_bottom"><router-link to="/Manual">操作マニュアル</router-link></li> -->
      <li class="li_bottom"><a :href="s3Url + 'manual/operating_manual.pdf'" target="_blank">操作マニュアル</a></li>
      <li class="li_bottom"><router-link to="/Setting">設定</router-link></li>
      <li class="li_bottom"><router-link to="/login">ログアウト</router-link></li>
    </div>
  </ul>
</template>

<script>
export default {
  data: function() {
    return {
      s3Url: process.env.VUE_APP_S3_BASEURL
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.side_menu {
  width: 180px;
  height: 100vh;
  float: left;
  color: #ffffff;
  background-color: #144974;
  padding: 0;
  font-size: large;
  position: relative;
}
.title {
  text-align: left;
  padding: 15px 10px;
  border-bottom: 0.1px solid #ffffff;
}
ul {
  text-align: left;
  list-style: none;
}
.d_bottom {
	position: absolute;
	bottom: 0;
  margin-top: 300px;
}
li {
  width: 180px;
  padding: 12px 12px 12px 10px;
  color: #ffffff;
  font-size: 0.7em;
}
.li_top {
  border-bottom: 0.1px solid #ffffff;
  background-color: #144974;
}
.li_bottom {
  border-top: 0.1px solid #ffffff;
  background-color: #144974;
  vertical-align: middle;
}
a {
  color: #ffffff;
}
</style>